import type { AdminFlowisAccount, FlowisAccountIdentifiers } from '../../api/types';

/**
 * The identifier fields as a form holds them — strings throughout, because an empty input is '' and
 * only becomes null on the way to the API.
 */
export interface IdentifierFormState {
  registrationNumber: string;
  taxId: string;
  vatId: string;
  participantId: string;
  countryCode: string;
}

export const emptyIdentifiers: IdentifierFormState = {
  registrationNumber: '',
  taxId: '',
  vatId: '',
  participantId: '',
  countryCode: '',
};

export function identifiersFrom(account: AdminFlowisAccount | null): IdentifierFormState {
  if (!account) return emptyIdentifiers;

  return {
    registrationNumber: account.registrationNumber ?? '',
    taxId: account.taxId ?? '',
    vatId: account.vatId ?? '',
    participantId: account.participantId ?? '',
    countryCode: account.countryCode ?? '',
  };
}

/** The API normalizes these anyway; trimming here only keeps a blank field from being sent as ''. */
export function identifiersToRequest(state: IdentifierFormState): FlowisAccountIdentifiers {
  const trimmed = (value: string) => (value.trim() === '' ? null : value.trim());

  return {
    registrationNumber: trimmed(state.registrationNumber),
    taxId: trimmed(state.taxId),
    vatId: trimmed(state.vatId),
    participantId: trimmed(state.participantId),
    countryCode: trimmed(state.countryCode),
  };
}
